import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ValchainLanding from "@/pages/ValchainLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ValchainLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
